import { useCallback, useState } from 'react'
import {
  NO_MAP_CARD,
  mapCardShown,
  onCardClick,
  onCardClose,
  onCardHover,
  type MapCardHit,
} from './hoverPinState'

/**
 * Карточка рубежа ИЭЗ: чей это рубеж и на каком основании.
 *
 * Зачем вообще. Свойства линии (тип, обе стороны, документ-основание и его
 * дата) приезжают с сервера с самого начала, но показать их было негде —
 * и вопрос «откуда взялась вот эта линия» приходилось решать запросом к базе
 * (бой 29.08.2026: владелец обвёл линию на скриншоте и спросил, чья она).
 * Линия на карте, которую нельзя назвать, — та же безымянная краска, ради
 * которой собирали единую легенду.
 *
 * Хук, а не копия в каждой странице: рубежи — общее наложение обоих разделов.
 */
export function useEezCard() {
  const [state, setState] = useState(NO_MAP_CARD)
  const handleHover = useCallback(
    (hit: MapCardHit | null) => setState(s => onCardHover(s, hit)),
    [],
  )
  const handleClick = useCallback((hit: MapCardHit) => setState(s => onCardClick(s, hit)), [])
  const close = useCallback(() => setState(s => onCardClose(s)), [])
  return { shown: mapCardShown(state), handleHover, handleClick, close }
}
